
import { motion } from 'framer-motion'
import React from 'react'

interface SlideInProps {
  children: React.ReactNode
  direction?: 'left' | 'right'
  delay?: number
}

const SlideIn: React.FC<SlideInProps> = ({ children, direction = 'left', delay = 0 }) => {
  const variants = {
    hidden: {
      opacity: 0,
      x: direction === 'left' ? -100 : 100, 
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.8,
        delay,
        ease: 'easeOut',
      },
    },
  }

  return (
    <motion.div
      variants={variants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }} 
    >
      {children}
    </motion.div>
  )
}

export default SlideIn
